import * as React from "react";
import Select from "react-select";
import {useStaffServices} from "./useStaffServices";
import {durationList} from "app/redux/businessServicesSlice";
import {EmployeesSliceState} from "app/redux/employeesSlice";
import classNames from "classnames";
import {find} from "lodash";
import {AsButton, AsInput, reactSelectStyles} from "app/subframe";
import {Trash2} from "lucide-react";

export interface StaffServicesProps {
    selectedEmployee: EmployeesSliceState;
}

export const StaffServices: React.FC<StaffServicesProps> = ({
                                                                selectedEmployee,
                                                            }) => {
    const {
        combinedCategories,
        durations,
        prices,
        setDuration,
        setPrice,
        dirtyServices,
        updatingServices,
        updateService,
        handleActiveToggle,
        activeStatus,
    } = useStaffServices({selectedEmployee});

    return (<div className="flex flex-col gap-6">
            {/*<SectionHeader title="Services & Pricing" />*/}


            <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-gray-900">Services & Pricing</h3>
                {/*<select*/}
                {/*    // onChange={(e) => {*/}
                {/*    //   if (e.target.value) {*/}
                {/*    //     addServiceToStaff(e.target.value);*/}
                {/*    //     e.target.value = '';*/}
                {/*    //   }*/}
                {/*    // }}*/}
                {/*    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
                {/*>*/}
                {/*    <option value="">Add Service</option>*/}
                {/*    /!*{availableServices*!/*/}
                {/*    /!*    .filter(service => !selectedEmployee.services.some((s: any) => s.id === service.id))*!/*/}
                {/*    /!*    .map(service => (<option key={service.id}*!/*/}
                {/*    /!*                             value={service.id}>{service.name}</option>))}*!/*/}
                {/*</select>*/}
            </div>


            {combinedCategories.map((category) => (<div
                    key={category.id}
                    className="flex flex-col "
                >
                    {/*<p className="text-zinc-700 font-semibold">{category.name}</p>*/}
                    {/*<Divider className="my-4 bg-neutral-50" />*/}
                    <div className="flex flex-col gap-4">
                        {category.services.map((service: any) => (<div
                                key={service.id}
                                className={classNames("flex flex-col justify-between items-center border p-4 rounded-lg"
                                    //   ,
                                    // {
                                    //   "border-neutral-50": !activeStatus[service.id],
                                    //   "border-[#a2e9c1]": activeStatus[service.id],
                                    // }
                                )}
                            >
                                <div className="flex w-full items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <p className="text-zinc-700 font-semibold">
                                            {service.title}
                                        </p>
                                        <span
                                            className="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded-full">
                              {category.name}
                            </span>
                                    </div>

                                    <div className={'flex gap-2 justify-center items-center'}>

                                        <div className="flex items-center space-x-4">
                                            <label className="flex items-center cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    checked={service.active}
                                                    onChange={(event) => handleActiveToggle(service.id, event.target.checked)}

                                                    className="mr-2 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                />
                                                <span className="text-sm text-gray-600 select-none">Enabled</span>
                                            </label>
                                            {/*<button*/}
                                            {/*    // onClick={() => removeServiceFromStaff(String(service.id))}*/}
                                            {/*    className="p-1 text-red-400 hover:text-red-600"*/}
                                            {/*    aria-label="Remove service"*/}
                                            {/*>*/}
                                            {/*    <Trash2 className="w-4 h-4"/>*/}
                                            {/*</button>*/}
                                        </div>


                                        {/*<Switch*/}
                                        {/*    color="success"*/}
                                        {/*    size="sm"*/}
                                        {/*    defaultSelected={service.active}*/}
                                        {/*    onChange={(event) =>*/}
                                        {/*        handleActiveToggle(service.id, event.target.checked)*/}
                                        {/*    }*/}
                                        {/*    aria-label="Service status"*/}
                                        {/*/>*/}
                                        <AsButton
                                            onClick={() => updateService(service.id)}
                                            variant="ghost"
                                            size="sm"
                                            disabled={!dirtyServices[service.id] || updatingServices[service.id]} // Disable if not dirty or updating
                                            loader={updatingServices[service.id]}
                                            text="Update"
                                            className={classNames({
                                                "hidden": !dirtyServices[service.id] || updatingServices[service.id],
                                            })}
                                        />
                                    </div>
                                </div>
                                <div
                                    className={classNames("flex w-full gap-4 transform transition-all duration-500", {
                                        "max-h-0 mt-0 hidden": !activeStatus[service.id],
                                        "max-h-[1000px] mt-2": activeStatus[service.id], // Adjust max-height based on expected content size
                                    })}
                                >
                                    <div className="flex w-full flex-col justify-center items-start">

                                        <label
                                            className="block text-sm font-medium text-gray-700 mb-2">Duration
                                            (minutes)</label>

                                        <Select
                                            className="w-full"
                                            value={{
                                                value: durations[service.id], label: find(durationList, {
                                                    duration: durations[service.id],
                                                })?.label,
                                            }}
                                            onChange={(newValue: any) => {
                                                const durationValue = newValue.value;
                                                setDuration({
                                                    id: service.id, duration: durationValue, label: find(durationList, {
                                                        duration: durationValue,
                                                    })?.label,
                                                });
                                            }}
                                            options={durationList.map(({duration, label}) => ({
                                                value: duration, label: label,
                                            }))}
                                            styles={{
                                                ...reactSelectStyles({
                                                    borderContainer: true,
                                                }), menuList: (provided) => ({
                                                    ...provided, height: "140px",
                                                }),
                                            }}
                                        />
                                    </div>
                                    <div className="flex flex-col w-full justify-center items-start">
                                        <label
                                            className="block text-sm font-medium text-gray-700 mb-2">Price
                                            ($)</label>

                                        <AsInput
                                            type="number"
                                            containerClassName="w-full"
                                            // classNames={{
                                            //   base: "w-full max-w-[120px]",
                                            //   inputWrapper:
                                            //     "border-[#F4F4F5] rounded shadow-sm border",
                                            //   input: "font-semibold",
                                            // }}
                                            value={prices[service.id] || ""}
                                            leading="$"
                                            onChange={(e) => setPrice({
                                                id: service.id, price: e.target.value,
                                            })}
                                        />
                                    </div>
                                </div>
                            </div>))}
                    </div>
                </div>))}
        </div>);
};
